import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const NotifiedHero = lazy(() => import('components/pages/Vans'))
const Footer = lazy(() => import('components/Layout/Footer'))

function Cookie() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <NotifiedHero />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default Cookie